/* AMD Steps to Success — video modal behaviour.
   Progressive enhancement: each trigger is a real <a> pointing at the MP4, so
   with JS disabled the browser opens and plays the file. With JS, the click is
   intercepted and the video plays inside a native <dialog> (focus trap, Esc
   and focus restore all come for free). */

class AmdStepsToSuccess extends HTMLElement {
  constructor() {
    super();
    this._onClick = this._onClick.bind(this);
    this._onDialogClose = this._onDialogClose.bind(this);
    this._dialogs = [];
  }

  connectedCallback() {
    this.addEventListener('click', this._onClick);

    this._dialogs = Array.from(this.querySelectorAll('[data-amd-sts-dialog]'));
    this._dialogs.forEach((dialog) => {
      dialog.addEventListener('close', this._onDialogClose);
    });
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick);

    this._dialogs.forEach((dialog) => {
      dialog.removeEventListener('close', this._onDialogClose);
    });
    this._dialogs = [];
  }

  _onClick(event) {
    const trigger = event.target.closest('[data-amd-sts-open]');
    if (trigger && this.contains(trigger)) {
      const dialog = this.querySelector('#' + window.CSS.escape(trigger.getAttribute('data-amd-sts-open')));
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        this._open(dialog);
      }
      return;
    }

    const closer = event.target.closest('[data-amd-sts-close]');
    if (closer && this.contains(closer)) {
      const dialog = closer.closest('[data-amd-sts-dialog]');
      if (dialog) dialog.close();
      return;
    }

    // Click on the backdrop: the dialog element itself fills the whole
    // viewport area, so a hit on it (and not on its children) is outside.
    const dialog = event.target.closest('[data-amd-sts-dialog]');
    if (dialog && event.target === dialog) dialog.close();
  }

  _open(dialog) {
    dialog.showModal();

    const player = dialog.querySelector('[data-amd-sts-player]');
    if (!player) return;

    const playing = player.play();
    if (playing && typeof playing.catch === 'function') {
      playing.catch(() => {});
    }
  }

  _onDialogClose(event) {
    const player = event.currentTarget.querySelector('[data-amd-sts-player]');
    if (!player) return;

    player.pause();
    player.currentTime = 0;
  }
}

if (!customElements.get('amd-steps-to-success')) {
  customElements.define('amd-steps-to-success', AmdStepsToSuccess);
}
